import ReactiveDialog from "components/common/ReactiveDialog";
import { AssignmentRequest } from "protogen/assignments_pb";
import { useRespondToAssignment } from "services/signup";
type Props = {
  isOpen: boolean;
  onClose: () => void;
  assignment: AssignmentRequest;
};

export default ({ isOpen, onClose, assignment }: Props) => {
  const { request: respondToAssignment, loading: respondingToAssignment } =
    useRespondToAssignment();
  const confirm = async () => {
    await respondToAssignment({
      assignmentRef: assignment.ref,
      responseStatus: "declined",
      declinedReason: "skipped",
    });
    onClose();
  };
  return (
    <ReactiveDialog
      primaryAction={confirm}
      primaryActionName={"Skip"}
      fullWidthSize="sm"
      primaryActionEnabled={!respondingToAssignment}
      open={isOpen}
      onClose={onClose}
      title={`Skip current candidate?`}
    ></ReactiveDialog>
  );
};
